import { base64ToByteArray } from './base64-to-byte-array';

export const base64ToBlob = (base64: string, mimeType: string) => {
  const byteArray = base64ToByteArray(base64);
  return new Blob([byteArray], { type: mimeType });
};
